import { bootstrapApplication } from '@angular/platform-browser'
import { setWorkerUrl } from 'maplibre-gl'
import { appConfig } from './app/app.config'
import { App } from './app/app'
import { initAdminSentry } from './app/core/observability/sentry'

initAdminSentry()
setWorkerUrl('/assets/maplibre/maplibre-gl-worker.mjs')

bootstrapApplication(App, appConfig).catch((error: unknown) => {
  console.error(error)
})
